import { COVER_URL } from "@/lib/api";
import { Link } from "react-router-dom";
import SocialLinks from "@/components/SocialLinks";

export default function About() {
  return (
    <div className="bg-ink min-h-screen" data-testid="about-page">
      <div className="max-w-4xl mx-auto px-5 md:px-10 py-12 md:py-20">
        <p className="scribble text-hotpink text-2xl mb-2 rotate-[-2deg] inline-block">written & narrated by</p>
        <h1 className="brush-title text-6xl md:text-8xl text-white mb-8">
          JOEY <span className="text-hotpink">ALVAREZ.</span>
        </h1>

        <div className="grid md:grid-cols-3 gap-10 items-start mb-12">
          <img src={COVER_URL} alt="If We Knew" className="w-full rotate-[-2deg] shadow-2xl border-4 border-white/10 md:col-span-1" />
          <div className="md:col-span-2 space-y-5 font-outfit text-white/85 text-lg leading-relaxed">
            <p>Joana "Joey" Alvarez is 36, sharp, and knows exactly how to spot a red flag—because she gets paid to.</p>
            <p>By day, she's a merchandiser for a luxury watch company in New York. By night, she runs <span className="text-hotpink font-bold">Red Flags</span>, a discreet side business where clients hire her to investigate the people they're dating. Lies, patterns, secrets—Joey sees what others miss.</p>
            <p className="scribble text-3xl text-hotpink rotate-[-1deg] inline-block">so why is her own love life a mess?</p>
            <p>Recently single after ending a 12-year relationship, Joey is pushed by her best friend <span className="font-bold text-white">Miriam</span> into the world of modern dating—starting with an app called <span className="text-hotpink font-bold">Mis-Match</span>, designed to pair you with your complete opposite.</p>
            <p>What follows is a series of unpredictable, funny, and sometimes painfully real encounters with men who are anything but ordinary.</p>
            <p>Each episode introduces a new date and experiences—Mr. No Follow-Up, Mr. Life Coach, Mr. Spreadsheet, Mr. Vegan Everything—men with their own quirks, contradictions, and red flags.</p>
            <p>Through it all, Joey observes, analyzes… and still gets caught off guard.</p>
            <p>Because no matter how much you know—</p>
            <p className="scribble text-3xl text-white">when it comes to love, we all miss something.</p>
            <p className="brush-title text-3xl text-hotpink">If we knew… would we make better choices?</p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <p className="scribble text-white/70 text-2xl mb-2">ready for the diary?</p>
            <SocialLinks size="md" />
            <a
              href="mailto:ifweknewaudio@outlook.com"
              data-testid="contact-email-about"
              className="block mt-3 text-white/60 hover:text-hotpink font-outfit text-sm transition-colors"
            >
              ifweknewaudio@outlook.com
            </a>
          </div>
          <Link to="/episodes" data-testid="about-to-episodes" className="bg-hotpink hover:bg-hotpink_dark text-white font-outfit font-extrabold uppercase tracking-widest text-sm px-7 py-4 shadow-[5px_5px_0px_#FFFFFF] hover:shadow-[7px_7px_0px_#FFFFFF] transition-all">
            Listen now — first 10 free →
          </Link>
        </div>
      </div>
    </div>
  );
}
